import { Directive, ElementRef, HostListener, Input, Renderer2, DoCheck} from '@angular/core';

@Directive({
  selector: '[sortable]'
})
export class SortableDirective implements DoCheck {

  @Input('sortable') field: string;
  @Input('sort-params') params: Filter;
  private asc: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2) { 
      this.renderer.addClass(this.el.nativeElement, "sortable");
  }
  
  @HostListener('click') onClick() {
    this.asc = !this.asc;
    this.params.sortBy = this.field;
    this.params.sortAsc = this.asc;

    this.params.onChange();
  }

  ngDoCheck() {
      this.asc = this.params.sortAsc;

      this.renderer.removeClass(this.el.nativeElement, 'sorted');
      this.renderer.removeClass(this.el.nativeElement, "asc");
      this.renderer.removeClass(this.el.nativeElement, "desc");

      if (this.params.sortBy == this.field) {
          this.renderer.addClass(this.el.nativeElement, 'sorted');
          this.renderer.addClass(this.el.nativeElement, this.asc ? "asc" : "desc");
      }
  }
}

interface Filter {
    sortBy: string;
    sortAsc: boolean;
    onChange: Function;
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/directives/sortable.directive.ts